export const FEATURE_NAMESPACE = 'feature.major-outage-lead-dashboard'
